var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-alt 1",
    clipPath: "url(#clip0_377_14131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4838 6.05043L18.6501 7.88406C18.4632 8.07101 18.1609 8.07101 17.9739 7.88406L13.5589 3.46902C13.372 3.28208 13.372 2.97979 13.5589 2.79285L15.3925 0.959213C16.1363 0.215418 17.3455 0.215418 18.0933 0.959213L20.4838 3.3497C21.2315 4.09349 21.2315 5.30266 20.4838 6.05043ZM11.9838 4.36794L1.53886 14.8129L0.695632 19.6456C0.580284 20.2979 1.14907 20.8627 1.80138 20.7513L6.63406 19.9041L17.079 9.45916C17.2659 9.27222 17.2659 8.96992 17.079 8.78298L12.664 4.36794C12.473 4.181 12.1708 4.181 11.9838 4.36794ZM5.61581 13.9179C5.39705 13.6992 5.39705 13.3492 5.61581 13.1304L11.7412 7.00503C11.9599 6.78627 12.31 6.78627 12.5287 7.00503C12.7475 7.2238 12.7475 7.57382 12.5287 7.79258L6.40336 13.9179C6.1846 14.1367 5.83458 14.1367 5.61581 13.9179ZM4.17993 17.263H6.08914V18.7069L3.52364 19.1563L2.28664 17.9193L2.7361 15.3538H4.17993V17.263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_14131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.3649,
    height: 20.3649,
    fill: "white",
    transform: "translate(0.678528 0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEdit);
export default __webpack_public_path__ + "static/media/profile-edit.3a63c4ff2cddc2e85f2a7cc4a914be29.svg";
export { ForwardRef as ReactComponent };